<template>
  <div id="langValue" class="layer" @pointerdown.stop>
    <div class="inner">
      <button type="button" class="btnClose" @click.stop="onClose"><span class="blind">X</span></button>
      <h2 class="layerTitle">{{locale.language_specific_set}}</h2>
      <div class="btnDefaultAll mb10">
        <button type="button" class="btn sizeXs" :disabled="disabled" @click.stop="setDefaultLang">{{locale.language_apply_default_value}}</button>


<!-- 자동으로 번역하기 -->
        <button
          v-if="isSuperadmin"
          type="button"
          class="btn btnWhite sizeXs btnAutoTranslate"
          @click.stop="autoTranslate">
          번역값 채워넣기
        </button>
<!-- //자동으로 번역하기 -->


      </div>
      <div class="langList formGroup">
        <div v-for="(l, index) in sort.usable" :key="index"
          :class="{langItem: true, isDefault: l.c === lang.default, inActive: inActive(l.c)}">
          <div class="label">
            <span :title="langName(l.c)">{{ langName(l.c) }}</span>
          </div>
          <textarea v-if="textarea" :disabled="disabled || disabledLangCodes?.includes(l.c)" v-model="langValue[l.c]" class="input"></textarea>
          <input v-else :disabled="disabled || disabledLangCodes?.includes(l.c)" v-model="langValue[l.c]" class="input">
        </div>
        <!-- 
        <button type="button" :data-more="viewmore" class="btnMore btn btnFull btnWhite sizeXs mt15" @click.stop="moreValues">
          {{`${locale.language_unused} (+ ${sort.unusable.length})`}}
          <img src="@/assets/img/ico_arrow.svg" alt="" />
        </button>
        <div v-if="viewmore" class="unusable mt15">
          <div v-for="(l, index) in sort.unusable" :key="index"
            :class="{langItem: true, isDefault: l.c === lang.default, inActive: inActive(l.c)}">
            <div class="label">
              <span :title="langName(l.c)">{{ langName(l.c) }}</span>
            </div>
            <textarea v-if="textarea" :disabled="disabled || disabledLangCodes?.includes(l.c)" v-model="langValue[l.c]" class="input"></textarea>
            <input v-else :disabled="disabled || disabledLangCodes?.includes(l.c)" v-model="langValue[l.c]" class="input">
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import LANG from '@/common/lang'

export default {
  name: 'LangValue',
  props: [
    'title',
    'langValue',
    'textarea',
    'disabled',
    'disabledLangCodes'
  ],
  computed: {
    locale () {
      return this.$store.state.service.locale.data
    },
    lang () {
      return this.$store.getters['setting/getData'].lang
    },
    sort () {
      // 기본 언어가 가장 위로 재정렬 (데이터에 직접 관여하지 않음)
      const langList = this.lang.info
      const defaultValue = langList.filter(x => x.c === this.lang.default)
      const usable = defaultValue.concat(langList.filter(x => x.u && x.c !== this.lang.default))
      const unusable = langList.filter(x => !x.u)
      return {
        usable: usable,
        unusable: unusable
      }
    },
    isSuperadmin () {
      return this.$store.getters['authentication/getAuthority']
    },
  },
  watch: {
    // langValue: {
    //   deep: true,
    //   handler (data) {
    //     this.ensureLangKeys()
    //   }
    // }
  },
  created () {
    this.ensureLangKeys()
    // this.$nextTick(() => {
    //   
    // })
  },
  data () {
    return {
      viewmore: false
    }
  },
  methods: {
    ensureLangKeys() {
      const LANG_USABLE = this.sort.usable.map(x => x.c)
      const LANG_DEFAULTS = this.$store.getters['setting/getLangValues']()
      let v = this.langValue; // props

      if (!v || typeof v !== 'object') return

      const nextValue = {};

      // 유효한 키만 새 객체에 복사
      for (const k of Object.keys(v)) {
        if (LANG_USABLE.includes(k)) {
          nextValue[k] = v[k]
        }
      }

      // 없는 언어 키 주입
      for (const k of Object.keys(LANG_DEFAULTS)) {
        if (!(k in nextValue)) {
          nextValue[k] = LANG_DEFAULTS[k]
        }
      }

      // 기존 객체의 내용을 일단 다 비움 (삭제 대신 빈 값을 할당)
      Object.keys(v).forEach(k => {
        if (!(k in nextValue)) {
          // 삭제가 안 먹힌다면 일단 값이라도 무효화
          this.$set(v, k, undefined)
          // 그 후 강제 삭제 시도
          this.$delete(v, k)
        }
      })

      // 새로운 값들로 덮어쓰기
      Object.assign(v, nextValue);

      // Vue에게 이 객체가 변했음을 강제로 알림
      this.$set(this, 'langValue', v)
    },
    langName (c) {
      const code = `lang_${c}`
      return this.locale[code]
    },
    setDefaultLang () {
      const defaultLang = this.lang.default
      const value = this.langValue
      Object.keys(value).forEach(function (x) {
        value[x] = value[defaultLang]
      })
    },
    inActive (code) {
      return !this.lang.usable.includes(code)
    },
    onClose () {
      this.$emit('close')
    },




    /**
     * 워커는 개인계정(무과금)
     * openai api는 회사개인계정
     */
    // 
    async autoTranslate () {
      const langs = this.lang
      const source = langs?.default
      const target = langs?.usable.filter(l => l !== source)
      const text = this.langValue[source]

      if (!text) return

      try {
        this.$store.commit('onLoading', true)
        const res = await fetch('https://translate-worker.yoomajor.workers.dev/translate', {
          method: 'POST',
          headers: {
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            q: text,
            source,
            target
          })
        })

        const data = await res.json()
        const translations = data?.translations || {}

        Object.keys(translations).forEach(code => {
          this.$set(this.langValue, code, translations[code] || '')
        })
      } catch (e) {
        console.error(e)
      } finally {
        this.$store.commit('onLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#langValue {
  .btnMore {
    background-color: rgba($color-lgrey2, 0.3);
    img {
      width: 16px;
      margin-left: 1em;
      opacity: 0.3;
    }
    &[data-more="true"] img {
      transform: rotate(180deg);
    }
  }
  .langItem {
    position: relative;
    padding: 0;
    border-bottom: none;
    &+.langItem {
      margin-top: 15px;
      border-top: none;
    }
    .label {
      position: absolute;
      top: 0;
      left: 0;
      width: 120px;
      height: 100%;
      margin-top: 0;
      margin-bottom: 0;
      span {
        position: absolute;
        top: 50%;
        max-width: calc(100% - 10px);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        transform: translate(10px, -50%);
      }
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        right: 0;
        height: 1em;
        border-right: 1px solid $color-lgrey2;
        transform: translate(0, -50%);
      }
    }
    .input {
      padding-left: calc(120px + 0.8em);
      border-color: $color-lgrey2;
    }
  }
  .unusable {
    color: $color-grey;
    .input {
      color: inherit;
    }
  }
}
.langList{
  max-height: 100%;
  overflow: auto;
}
.isDefault {
  .label {
    color: $color-primary;
  }
}
.inActive .input {
  background-color: rgba($color-lgrey2, 0.3);
}
.btnAutoTranslate {
  margin-left: 12px;
}
</style>
